module.exports = __webpack_public_path__ + "media/images/img_search04-b41671b09e5bd9eac1dbb548ebaca6a6.png";